import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "fill"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SVGIcon',
  props: {
  path: {
    type: String,
    required: true
  },
  size: {
    type: [String, Number],
    default: 16,
    validator: (value: string | number) => {
      return !isNaN(Number(value));
    }
  },
  color: {
    type: String,
    default: ""
  },
  customClass: {
    required: false,
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: "",
    required: false,
    validator: (value: string) => {
      return value
        ? [
            "is-dark",
            "is-light",
            "is-success",
            "is-danger",
            "is-warning",
            "is-white"
          ].includes(value)
        : true;
    }
  }
},
  setup(__props) {

const props = __props;

const fillColor = computed<string>(() => {
  if (props.color) {
    return props.color;
  }

  const colorMap: { [key: string]: string } = {
    "is-dark": "#1b1b1b",
    "is-white": "#ffffff",
    "is-light": "#bebebe",
    "is-warning": "#ffa500",
    "is-danger": "#e44e4e",
    "is-success": "#48ad93"
  };

  return props.type && colorMap[props.type]
    ? colorMap[props.type]
    : "currentColor";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 24 24",
    class: _normalizeClass(__props.customClass)
  }, [
    _createElementVNode("path", {
      d: __props.path,
      fill: fillColor.value
    }, null, 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})